import {type ReactNode} from 'react'
import {Navigate} from 'react-router-dom'
import {Box} from '@mui/material'
import {useAuth} from './useAuth'
import LoadingLogo from '../components/LoadingLogo'

interface RequireAuthProps {
  children: ReactNode
}

const RequireAuth = ({children}: RequireAuthProps) => {
  const {user, loading} = useAuth()

  if (loading) {
    return (
      <Box sx={styles.loader}>
        <LoadingLogo size={48} />
      </Box>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  return children
}

const styles = {
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
} as const

export default RequireAuth
